import { createContext, useContext, useEffect, useState, ReactNode } from 'react'

export type Platform = 'desktop' | 'mobile-web' | 'capacitor'

const PlatformContext = createContext<Platform>('desktop')

function detectPlatform(): Platform {
  if (typeof (window as any).Capacitor !== 'undefined' && (window as any).Capacitor.isNativePlatform()) {
    return 'capacitor'
  }
  return window.innerWidth < 768 ? 'mobile-web' : 'desktop'
}

export function PlatformProvider({ children }: { children: ReactNode }) {
  const [platform, setPlatform] = useState<Platform>(detectPlatform)

  useEffect(() => {
    const ro = new ResizeObserver(() => {
      if (platform !== 'capacitor') {
        setPlatform(detectPlatform())
      }
    })
    ro.observe(document.body)
    return () => ro.disconnect()
  }, [platform])

  return (
    <PlatformContext.Provider value={platform}>
      {children}
    </PlatformContext.Provider>
  )
}

export function usePlatform(): Platform {
  return useContext(PlatformContext)
}
